// removed by extract-text-webpack-plugin
module.exports = {"button":"CalendarDayButton__button__1IpQF","dayNumber":"CalendarDayButton__dayNumber__nnCOV","dayLabel":"CalendarDayButton__dayLabel__sO0Wj","bigText":"CalendarDayButton__bigText__sXWj_","active":"CalendarDayButton__active__16YyE"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/CalendarDayButton/CalendarDayButton.css
// module id = 463
// module chunks = 0